import React, { PureComponent } from 'react';
import queryString from 'query-string';
import AppProvider, { withApi } from './context/AppContext';
import ConfigPage from './pages/ConfigPage';
import OrderPage from './pages/OrderPage';
import { getDealInfo } from './helper/dealer';
import './App.css';

export default class App extends PureComponent {
  constructor(props) {
    super(props);
    this.orderId = this.props.match.params.orderId;
    const search = queryString.parse(window.location.search);
    this.orderHash = search.hash;
    this.token = search.token;
    this.org = search.org;
    this.dealer = getDealInfo();
  }
  render() {
    const Page = this.orderId ? OrderPage : ConfigPage;
    return (
      <AppProvider
        orderId={this.orderId}
        orderHash={this.orderHash}
        token={this.token}
        org={this.org}
        dealer={this.dealer}
      >
        <div id="appRoot" className="threekit">
          {withApi(Page)({})}
        </div>
      </AppProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js